module.exports = __webpack_public_path__ + "media/images/spirits-aacebc87233ebb43795d7f30d95db451.png";